import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const PagesGenericStyling = styled.div`
  max-width: 100%;
  height: 100%;
  position: relative;
  margin: ${props =>
    props.showDiscountBanner
      ? `95px ${theme.grid.resolution.mobile.margin}px`
      : `0 ${theme.grid.resolution.mobile.margin}px`};
  .unnecessary-wrapper {
    position: relative;
  }
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: ${theme.grid.resolution.tablet.container}px;
    margin: ${props => (props.showDiscountBanner ? `72px auto` : `0 auto`)};
  }
  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }
  .lead-title {
    color: ${theme.primaryColours.aubergine.main};
    max-width: 632px;
  }
  .info-wrapper {
    .info {
      z-index: 2;
    }
  }
`
